import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const rootElement = document.getElementById("root");

// When react-snap has pre-rendered the page, the root already has markup —
// hydrate it. Otherwise (normal dev / un-prerendered), create a fresh root.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}
